import { lazy, Suspense } from 'react';

import { RequireAnyRole } from '../components/AuthGuards/RequirePermission';

const ProfilePage = lazy(() => import('../pages/Profile'));

export const ProfileRoutes = [
  {
    path: 'profile',
    // Every signed-in account with a role (28 Oct, Joey): My profile is where Change password and Log out are, so
    // nobody may be locked out of it. It used to need licence.read, which a Content Manager (lic-content) does not
    // hold. The page gates its own parts: My orders and Payment still need licence.read, usable (ProfileInfo.tsx).
    element: (
      <RequireAnyRole>
        <Suspense fallback={<></>}>
          <ProfilePage />
        </Suspense>
      </RequireAnyRole>
    ),
  },
];
